import { useId } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import {
  COVERAGE_TYPES_FIELD,
  SPLIT_GROUP_FIELD,
  objektSpartenOfType,
} from "../FormDefinitionRenderer/coverageSelection.js";
import {
  useFormCoverage,
  useFormEditMode,
} from "../FormDefinitionRenderer/contexts.js";

const LABEL = "Welche Sparte ist betroffen?";

/**
 * Top of a Sparte step: chooses which Objektsparte of the coverage type is
 * affected, when the Objekt has several. Replaces the entry in `_coverage_types`.
 */
export default function CoverageSparteSelect({ coverageType }) {
  const id = useId();
  const { setValue } = useFormContext();
  const { objektSparten } = useFormCoverage();
  const editMode = useFormEditMode();
  const selected = useWatch({ name: COVERAGE_TYPES_FIELD }) ?? [];
  const split_group = useWatch({ name: SPLIT_GROUP_FIELD });

  const of_type = objektSpartenOfType(objektSparten, coverageType);
  if (split_group || of_type.length < 2) return null;

  const current =
    selected.find((id) => of_type.some((sparte) => sparte.sparte_id === id)) ??
    "";

  return (
    <FormControl fullWidth sx={{ mb: 2 }}>
      <InputLabel id={`${id}-label`}>{LABEL}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={`${id}-select`}
        label={LABEL}
        value={current}
        disabled={!editMode}
        onChange={(event) =>
          setValue(
            COVERAGE_TYPES_FIELD,
            selected.map((id) => (id === current ? event.target.value : id)),
            { shouldDirty: true }
          )
        }
      >
        {of_type.map((sparte) => (
          <MenuItem key={sparte.sparte_id} value={sparte.sparte_id}>
            {sparte.sparte}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
